import {FetchMode, ItemSelectComponent} from './item-select.component';
import { Component, forwardRef, Input, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {PageResponse} from '../../models/page-response';
import {ProjectRelationService} from '../../services/project-relation.service';
import {ProjectRelationRole} from '../../models/project-relation-role';
import {map, shareReplay} from 'rxjs/operators';

@Component({
    selector: 'app-relation-type-select',
    templateUrl: './item-select.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RelationRoleSelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class RelationRoleSelectComponent extends ItemSelectComponent<ProjectRelationRole, {}> {
    private projectRelationService = inject<ProjectRelationService>('ProjectRelationService' as any);

    @Input() excludedRoles: string[] = [];

    $relationRoles = this.projectRelationService.listRelationRoles().pipe(
        shareReplay(1)
    );

    constructor() {
        super(FetchMode.Full);
    }

    getLabelText(item: ProjectRelationRole): string {
        return item.value;
    }

    loadMoreItems(filter: { term: string }): Observable<ProjectRelationRole[]> {
        return this.$relationRoles.pipe(
            map(items => items.filter(it => it.value.toLowerCase().includes((filter.term || '').toLowerCase()))),
            map(items => items.filter(it => !this.excludedRoles.includes(it.key)))
        );
    }

    compare(a: ProjectRelationRole, b: ProjectRelationRole): boolean {
        if (!a || !b) {
            return false;
        }

        return a.key === b.key;
    }
}
